import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import splashLogo from "../assets/favicon-black.png";
import "./SplashScreen.css";
import { FaArrowRight } from "react-icons/fa";

const SplashScreen = ({ onSplashComplete }) => {
    const navigate = useNavigate();
    const [loadingComplete, setLoadingComplete] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [arrowPosition, setArrowPosition] = useState(false);
    const [textVisible, setTextVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => {
            setLoadingComplete(true);
        }, 500);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    const handleLanguageChange = (event) => {
        setSelectedLanguage(event.target.value);
    };

    const handleArrowClick = () => {
        if (selectedLanguage && selectedLanguage !== "") {   // ✅ Ensure valid selection
            setTextVisible(false);
            setArrowPosition(true);
    
            setTimeout(() => {
                sessionStorage.setItem("splashShown", "true"); // Set session flag
                sessionStorage.setItem("selectedLanguage", selectedLanguage);  // Store language selection
                onSplashComplete(); // Notify App.js that splash is complete
                navigate("/"); // Redirect to UserTypeSelection
            }, 1000);
        } else {
            alert("Please select a language before proceeding.");
        }
    };
    
    

    return (
        <div className="Splash-screen">
        <div className="Splash-content">
            {!loadingComplete && (
            <>
                <img
                src={splashLogo}
                alt="Kaam Sathi Logo"
                className={`Splash-logo ${fadeOut ? "fade-out" : ""}`}
                />
                <h1 className={`Splash-title ${fadeOut ? "fade-out" : ""}`}>
                KaamSaathi
                </h1>
                <div className="Splash-loading-bar">
                    <div className="progress">
                    </div>
                </div>
            </>
            )}

            {loadingComplete && (
            <>
                <div className="language-selector">
                <p className="language-label">Choose Your Language:</p>
                <select className="language-dropdown" onChange={handleLanguageChange} value={selectedLanguage || ""} >
                    <option value="" disabled>Select Language</option>
                    <option value="en">English</option>
                    <option value="hi">हिन्दी</option>
                    <option value="mr">मराठी</option>
                </select>
                </div>
                <div
                className={`right-arrow ${arrowPosition ? "move-right" : ""}`}
                onClick={handleArrowClick}
                >
                {textVisible && (
                    <span
                    style={{
                        marginRight: "10px",
                        color: "#fff",
                        fontSize: "20px",
                        fontFamily: "Raleway",
                        fontWeight: "600",
                    }}
                    >
                    Continue
                    </span>
                )}
                <FaArrowRight size={25} color="#fff" />
                </div>
            </>
            )}
        </div>
        </div>
    );
};

export default SplashScreen;
